import { isNull } from 'lodash-es'
import Link from 'next/link'

import { formatDateWithDayOfWeek } from '@/shared/lib'
import { Button, Dialog } from '@/shared/ui'

import { useGuestDepositReturnCard } from '../../api/get-guest-deposit-return-card'

type Props = {
  isOpen: boolean
  onOpenChange: (isOpen: boolean) => void
  contractId: number
}

export const UpdateDepositReturnCardDialog = ({
  isOpen,
  onOpenChange,
  contractId,
}: Props) => {
  const { depositReturnCard } = useGuestDepositReturnCard({
    contractId,
  })

  const isDepositReturned =
    depositReturnCard?.isDepositReturned &&
    !isNull(depositReturnCard?.depositReturnedAt)

  return (
    <Dialog.Root open={isOpen} onOpenChange={onOpenChange}>
      <Dialog.Content className="h-[362px] gap-0 p-0">
        <Dialog.Header className="p-6">
          <Dialog.Title className="text-start">보증금 반환 정보</Dialog.Title>
        </Dialog.Header>
        <div className="grow px-6">
          <h3 className="typo-body1 mb-3 font-semibold text-black">신용카드</h3>

          <div className="mb-4 space-y-2">
            <p className="typo-label1 font-medium text-gray-900">
              {depositReturnCard?.cardName} {depositReturnCard?.cardNo}
            </p>

            {isDepositReturned && (
              <p className="typo-body1 font-bold text-purple-500">
                {formatDateWithDayOfWeek({
                  date: depositReturnCard.depositReturnedAt!,
                })}{' '}
                반환 완료
              </p>
            )}

            <p className="typo-label2 font-normal text-gray-500">
              반환 완료 후, 3~7일 이내 카드 취소로 환불됩니다.
              <br />
              정확한 환불일은 카드사에 문의주시기 바랍니다.
            </p>
          </div>

          {isDepositReturned && (
            <Button
              variant="outline"
              size="medium"
              shape="pill"
              fullWidth
              asChild
            >
              <Link
                href={depositReturnCard.cardReceiptUrl ?? ''}
                target="_blank"
                rel="noopener noreferrer"
              >
                카드 전표
              </Link>
            </Button>
          )}
        </div>
        <Dialog.Footer className="flex-row gap-2.5 p-6">
          <Dialog.Close asChild>
            <Button
              type="button"
              variant="solid"
              color="secondary"
              size="large"
              fullWidth
            >
              닫기
            </Button>
          </Dialog.Close>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog.Root>
  )
}
